export default {
	"5eb3691d4671db91e8cb1d20eac61229": "Modify the address",
	"5a26bed5c41d0dd829351938187fa41c": "Confirm the modification",
	"cf388516821123b8af72ec6857fac644": "Please select the address first",
	"445b471e1e1474044e8951d51c11930a": "Modification failed",
	"2f4021322baf0748f78129c57c34a5c3": "The address modification was successful.",
	"3c507c8abe8c194e9dd70c6b5da3f657": "Address management",
	"94725d8f14ecfd6d5849cb868fc767cb": "Original address",
	"6e2a9e4ce1c6d8bad171f15b9727b3ae": "Select a new delivery address",
	"4c0cfa335ec73e77ceb7fee59c61bb3a": "You don't have the delivery address yet ~"
}
